import { render, staticRenderFns } from "./errorAlert.vue?vue&type=template&id=7244664e&scoped=true&"
import script from "./errorAlert.vue?vue&type=script&lang=js&"
export * from "./errorAlert.vue?vue&type=script&lang=js&"
import style0 from "./errorAlert.vue?vue&type=style&index=0&id=7244664e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7244664e",
  null
  
)

export default component.exports